import React, { useState } from 'react';
import './App.css';
import Header from '../components/Header/Header';
import ExpenseForm from '../components/ExpenseForm/ExpenseForm';
import NotionDataTable from '../components/NotionDataTable/NotionDataTable';
import AccessRequestButton from '../components/AccessRequestButton/AccessRequestButton';
import { AuthProvider, useAuth } from '../contexts/AuthContext';

function AppContent() {
  const [currentPage, setCurrentPage] = useState('form'); // 'form' or 'table'
  const { user, loading, refreshAuth } = useAuth();
  const [checkingAccess, setCheckingAccess] = useState(false);

  const handleAddExpense = () => {
    // Expense added successfully
  };

  // Periodically check for access updates
  React.useEffect(() => {
    const hasAccess = user && (user.allowed === true || user.allowed === 1 || user.role === 'admin');
    if (user && !hasAccess && !checkingAccess) {
      const interval = setInterval(async () => {
        setCheckingAccess(true);
        await refreshAuth();
        setCheckingAccess(false);
      }, 2000); // Check every 2 seconds

      return () => clearInterval(interval);
    }
  }, [user, checkingAccess, refreshAuth]);

  if (loading) {
    return (
      <div className="app">
        <main className="main-content">
          <div style={{ textAlign: 'center', padding: '40px' }}>Загрузка...</div>
        </main>
      </div>
    );
  }

  const hasAccess = user && (user.allowed === true || user.allowed === 1 || user.role === 'admin');

  if (!hasAccess) {
    return (
      <div className="app">
        <main className="main-content">
          <AccessRequestButton />
        </main>
      </div>
    );
  }

  return (
    <div className="app">
      <Header currentPage={currentPage} onPageChange={setCurrentPage} />
      <main className="main-content">
        {currentPage === 'form' ? (
          <ExpenseForm onAdd={handleAddExpense} />
        ) : (
          <NotionDataTable />
        )}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;

